import { useMemo } from 'react';
import Grid from '@mui/material/Grid2';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function CandidateInfo({
  label,
  value,
  description,
  tooltip,
  wrap = false,
  capitalize = true,
}: {
  label: string;
  value?: string | null | React.ReactNode;
  description?: string | null;
  tooltip?: string;
  wrap?: boolean;
  capitalize?: boolean;
}) {
  const textStylesSx = useMemo(
    () => ({ overflowWrap: wrap ? 'anywhere' : 'normal' }),
    [wrap],
  );

  return (
    <Grid container spacing={1} flexDirection="column">
      <Grid container spacing={0.5} alignItems="center">
        <Typography variant="h5" color="grey.600">
          {label}
        </Typography>
        {tooltip && (
          <Tooltip title={tooltip} arrow>
            <InfoOutlinedIcon fontSize="small" color="action" />
          </Tooltip>
        )}
      </Grid>
      <Typography
        variant="h5"
        color="black"
        sx={textStylesSx}
        textTransform={capitalize ? 'capitalize' : 'none'}
      >
        {value || '-'}
      </Typography>
      {description && (
        <Typography fontSize={12} fontWeight={600}>
          {description}
        </Typography>
      )}
    </Grid>
  );
}
